import JSON5 from "json5";

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function parseCustomJsonString(input: string): object {
  // Remove any surrounding quotes if present
  let cleanInput = input.replace(/^"(.*)"$/, "$1");

  // Remove duplication if present
  if (cleanInput.length % 2 === 0) {
    const halfLength = cleanInput.length / 2;
    if (cleanInput.slice(0, halfLength) === cleanInput.slice(halfLength)) {
      cleanInput = cleanInput.slice(0, halfLength);
    }
  }

  // Replace escaped newlines with actual newlines
  cleanInput = cleanInput.replace(/\\n/g, "\n");

  // Parse with JSON5
  try {
    const parsed = JSON5.parse(cleanInput);

    // Stringify and re-parse to ensure all keys are quoted
    return JSON.parse(JSON.stringify(parsed));
  } catch (error) {
    console.error("Error parsing JSON:", error);
    throw error;
  }
}

export function mergeAndDeduplicate(arr1: string[], arr2: string[]) {
  return Array.from(new Set([...arr1, ...arr2]));
}

export function getFileExtension(url: string) {
  try {
    const pathname = new URL(url).pathname;
    const extension = pathname.split(".").pop();
    return extension?.includes("/") ? null : extension;
  } catch {
    return null;
  }
}
